import {FORM_TYPE} from "@lib/Form/FormModels";
import {EventFilters} from "@lib/Event/EventModels";
import {RedemptionFilters} from "@lib/Redemption/RedemptionModels";
import {TransactionFilters} from "@lib/Transaction/TransactionModels";
import {PaginationParameters} from "@api/ApiModels";

export const qk = {
    projectSettings: (b2cCountry: string) => ["project", "id", b2cCountry] as const,
    jnextUser: () => ["me", "user"] as const,
    formConfig: (type: FORM_TYPE) => ["form", type] as const,
    wallet: () => ["wallet"] as const,
    invoiceIssues: () => ["issues", "invoice"] as const,
    contactIssues: () => ["issues", "contact"] as const,
    cart: () => ["cart"] as const,
    products: (size?: number) => ["products", size ?? "all"] as const,
    product: (productId?: string) => ["products", productId ?? "no_id"] as const,
    events: (filters: EventFilters = {}) => ["events", {...filters}] as const,
    event: (eventId?: string) => ["events", eventId ?? "no_id"] as const,
    invoices: (filters: PaginationParameters = {}) => ["invoices", {...filters}] as const,
    invoice: (invoiceId?: string) => ["invoices", invoiceId ?? "no_id"] as const,
    redemptions: (filters: RedemptionFilters = {}) => ["redemptions", {...filters}] as const,
    redemption: (rdmId?: string) => ["redemptions", rdmId ?? "no_id"] as const,
    transactions: (filters: TransactionFilters = {}) => ["transactions", {...filters}] as const,
    ssoFinalizationForm: () => ["sso-finalization-form"] as const,
    pointsCapCheck: () => ["pointscap"] as const,
};
